<template>
  <div class="py-4">
    <div class="mb-2 d-flex d-md-none d-lg-none align-center justify-end">
      <v-tooltip v-auth-acl="vAuthAcl + '-import'" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" fab dark small class="mr-2" @click="openDialogImportar" v-bind="attrs" v-on="on">
            <v-icon dark>mdi-cloud-upload</v-icon>
          </v-btn>
        </template>
        <span>Importar Información</span>
      </v-tooltip>
      <v-tooltip v-auth-acl="vAuthAcl + '-export'" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" fab dark small @click="exportarbase" v-bind="attrs" v-on="on">
            <v-icon dark>mdi-cloud-download</v-icon>
          </v-btn>
        </template>
        <span>Exportar BD</span>
      </v-tooltip>
    </div>
    <v-data-table
      dense
      :headers="headers"
      :items="listado"
      class="border"
      multi-sort
      :mobile-breakpoint="0"
      :items-per-page="-1"
      no-results-text="No se encontraron datos"
      no-data-text="No se encontraron datos"
      :search="search"
      item-class="class"
      :fixed-header="true"
      :height="height"
    >
      <template v-slot:top>
        <div class="w-100 d-flex justify-space-between align-center pa-2">
          <div class="black--text">PROYECCIÓN MO</div>
          <v-divider class="mx-4" vertical></v-divider>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            class="mt-0 pt-0 text-field-search-matriz"
            background-color="rgb(220, 220, 220, 0.16)"
            rounded
            single-line
            hide-details
          ></v-text-field>
          <v-divider class="d-none d-md-flex d-lg-flex mx-4" vertical></v-divider>
          <div class="w-30 d-none d-md-flex d-lg-flex justify-space-between align-center">
            <v-tooltip v-auth-acl="vAuthAcl + '-export'" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" fab dark small class="mr-2" @click="exportarbase" v-bind="attrs" v-on="on">
                  <v-icon dark>mdi-cloud-download</v-icon>
                </v-btn>
              </template>
              <span>Exportar BD</span>
            </v-tooltip>
            <v-tooltip v-auth-acl="vAuthAcl + '-import'" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" fab dark small @click="openDialogImportar" v-bind="attrs" v-on="on">
                  <v-icon dark>mdi-cloud-upload</v-icon>
                </v-btn>
              </template>
              <span>Importar Información</span>
            </v-tooltip>
          </div>
        </div>
      </template>
      <template v-slot:[`item.activo`]="{ item }">
        <v-icon :color="item.activo == 1 ? 'green' : 'red darken-2'" small>
          {{ item.activo == 1 ? 'mdi-check' : 'mdi-close' }}
        </v-icon>
      </template>
    </v-data-table>
    <div v-if="showLoading" class="progress-background">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
    <Importar
      v-auth-acl="vAuthAcl + '-import'"
      :dialog="dialogImportar"
      @close="closeImportar"
      @importar="importar"
    ></Importar>
  </div>
</template>

<script>
import MatrizService from '../services/MatrizService';
import moment from 'moment';
import Swal from 'sweetalert2';
export default {
  name: 'MatrizLista',
  components: {
    Importar: () => import('../components/Importar')
  },
  data: () => ({
    height: 130,
    search: '',
    dialogImportar: false,
    showLoading: false,
    matrizService: null,
    headers: [
      { text: 'N°', value: 'numero', width: '60', class: 'primary' },
      { text: 'EMPRESA', value: 'idempresa', width: '120', class: 'primary' },
      { text: 'LOCACIÓN', value: 'idlocacionbudget', width: '120', class: 'primary' },
      { text: 'CULTIVO ÁREA', value: 'cultivoarea', width: '160', class: 'primary' },
      { text: 'S1', value: 'S1', width: '100', class: 'primary' },
      { text: 'S2', value: 'S2', width: '100', class: 'primary' },
      { text: 'S3', value: 'S3', width: '100', class: 'primary' },
      { text: 'S4', value: 'S4', width: '100', class: 'primary' },
      { text: 'S5', value: 'S5', width: '100', class: 'primary' },
      { text: 'S6', value: 'S6', width: '100', class: 'primary' },
      { text: 'S7', value: 'S7', width: '100', class: 'primary' },
      { text: 'S8', value: 'S8', width: '100', class: 'primary' },
      { text: 'S9', value: 'S9', width: '100', class: 'primary' },
      { text: 'S10', value: 'S10', width: '100', class: 'primary' },
      { text: 'S11', value: 'S11', width: '100', class: 'primary' },
      { text: 'S12', value: 'S12', width: '100', class: 'primary' },
      { text: 'S13', value: 'S13', width: '100', class: 'primary' },
      { text: 'S14', value: 'S14', width: '100', class: 'primary' },
      { text: 'S15', value: 'S15', width: '100', class: 'primary' },
      { text: 'S16', value: 'S16', width: '100', class: 'primary' },
      { text: 'S17', value: 'S17', width: '100', class: 'primary' },
      { text: 'S18', value: 'S18', width: '100', class: 'primary' },
      { text: 'S19', value: 'S19', width: '100', class: 'primary' },
      { text: 'S20', value: 'S20', width: '100', class: 'primary' },
      { text: 'S21', value: 'S21', width: '100', class: 'primary' },
      { text: 'S22', value: 'S22', width: '100', class: 'primary' },
      { text: 'S23', value: 'S23', width: '100', class: 'primary' },
      { text: 'S24', value: 'S24', width: '100', class: 'primary' },
      { text: 'S25', value: 'S25', width: '100', class: 'primary' },
      { text: 'S26', value: 'S26', width: '100', class: 'primary' },
      { text: 'S27', value: 'S27', width: '100', class: 'primary' },
      { text: 'S28', value: 'S28', width: '100', class: 'primary' },
      { text: 'S29', value: 'S29', width: '100', class: 'primary' },
      { text: 'S30', value: 'S30', width: '100', class: 'primary' },
      { text: 'S31', value: 'S31', width: '100', class: 'primary' },
      { text: 'S32', value: 'S32', width: '100', class: 'primary' },
      { text: 'S33', value: 'S33', width: '100', class: 'primary' },
      { text: 'S34', value: 'S34', width: '100', class: 'primary' },
      { text: 'S35', value: 'S35', width: '100', class: 'primary' },
      { text: 'S36', value: 'S36', width: '100', class: 'primary' },
      { text: 'S37', value: 'S37', width: '100', class: 'primary' },
      { text: 'S38', value: 'S38', width: '100', class: 'primary' },
      { text: 'S39', value: 'S39', width: '100', class: 'primary' },
      { text: 'S40', value: 'S40', width: '100', class: 'primary' },
      { text: 'S41', value: 'S41', width: '100', class: 'primary' },
      { text: 'S42', value: 'S42', width: '100', class: 'primary' },
      { text: 'S43', value: 'S43', width: '100', class: 'primary' },
      { text: 'S44', value: 'S44', width: '100', class: 'primary' },
      { text: 'S45', value: 'S45', width: '100', class: 'primary' },
      { text: 'S46', value: 'S46', width: '100', class: 'primary' },
      { text: 'S47', value: 'S47', width: '100', class: 'primary' },
      { text: 'S48', value: 'S48', width: '100', class: 'primary' },
      { text: 'S49', value: 'S49', width: '100', class: 'primary' },
      { text: 'S50', value: 'S50', width: '100', class: 'primary' },
      { text: 'S51', value: 'S51', width: '100', class: 'primary' },
      { text: 'S52', value: 'S52', width: '100', class: 'primary' },
      { text: 'ACTIVO', value: 'activo', width: '100', class: 'primary' }
    ],
    listado: [],
    vAuthAcl: 'gh-pres-proyeccion-mo'
  }),
  computed: {},
  watch: {},
  methods: {
    async openDialogImportar() {
      this.dialogImportar = true;
    },
    async exportarbase() {
      const confirmed = await Swal.fire({
        icon: 'warning',
        title: '¿Está seguro de exportar la información?',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        showCancelButton: true
      });
      if (confirmed.isConfirmed) {
        this.showLoading = true;
        const fecha1 = moment().format('YYYYMMDDHHMMSS');
        const nombreentregable = 'EXPORT-PROYECCION-MO-' + fecha1 + '.xlsx';
        const token = localStorage.getItem('token');
        await this.matrizService.downloadResource(
          'exportarProyeccionMO',
          {
            token: token
          },
          nombreentregable
        );
        this.showLoading = false;
      }
    },
    async initialize() {
      this.showLoading = true;
      this.listado = [];
      const res = await this.matrizService.get().execResource('listarProyeccionMO');
      await this.$store.dispatch('cargarProyeccionMO', res);
      this.listado = res.map((element, index) => {
        return { numero: index + 1, ...element };
      });
      this.height = 400;
      this.showLoading = false;
    },
    async alertDialog(type, title) {
      return await Swal.fire({
        icon: type,
        title: title,
        confirmButtonText: `OK`
      });
    },
    closeImportar() {
      this.dialogImportar = false;
    },
    async importar(listado) {
      this.showLoading = true;
      const res = await this.matrizService.post().execResource('importarProyeccionMO', {
        movproyeccion_mo: listado
      });
      this.alertDialog(res.status ? 'success' : 'error', res.data);
      if (res.status) {
        this.initialize();
        this.$refs.importar.close();
      }
      this.showLoading = false;
    }
  },
  async mounted() {},
  async created() {
    this.matrizService = this.$httpService(new MatrizService(), this);
    //await this.permisos();
    await this.initialize();
  }
};
</script>
<style lang="scss">
.header-items-fixed-ind {
  position: sticky !important;
  position: -webkit-sticky !important;
}

.header-items-fixed-ind.nth-child1 {
  left: 0;
  z-index: 4 !important;
}
.header-items-fixed-ind.nth-child2 {
  top: 0;
  left: 100px;
  border-right: thin solid rgba(250, 250, 250) !important;
  z-index: 4 !important;
}
.class-items-fixed-ind td:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 3;
}
.class-items-fixed-ind td:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 100px;
  z-index: 3;
}
.cell-d-none td:last-child {
  display: none;
}
.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr > th {
  z-index: 3;
  color: white !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr .header-items-fixed-ind {
  background: white;
  color: rgba(0, 0, 0, 0.6);
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > thead > tr .header-items-fixed-ind {
  background: #1e1e1e;
  color: rgba(255, 255, 255, 0.7);
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(1) {
  background: white;
  color: rgba(0, 0, 0, 0.87);
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(1) {
  background: #1e1e1e;
  color: white;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(2) {
  background: white;
  color: rgba(0, 0, 0, 0.87);
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.theme--dark.v-data-table > .v-data-table__wrapper > table > tbody > .class-items-fixed-ind td:nth-child(2) {
  background: #1e1e1e;
  color: white;
  border-right: thin solid rgba(255, 255, 255, 0.12);
}

.text-field-search-matriz.theme--light.v-input input,
.theme--dark.v-input textarea {
  color: rgba(0, 0, 0, 0.87);
}
.text-field-search-matriz.theme--dark.v-input input,
.theme--dark.v-input textarea {
  color: rgba(0, 0, 0, 0.87) !important;
}

.text-field-search-matriz .v-input__control .v-input__slot .v-text-field__slot .theme--light.v-label {
  color: rgba(0, 0, 0, 0.6);
}

.text-field-search-matriz .v-input__control .v-input__slot .v-text-field__slot .theme--dark.v-label {
  color: rgba(0, 0, 0, 0.6);
}
</style>
